module.exports = __webpack_public_path__ + "static/img/partner13.e53391c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner13.png
// module id = o00W
// module chunks = 0